import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_SUPPORTER_GROWTH_PSF_RECOMMENDED_GROUPS_EXPERIMENT = defineFcm(
	'supporter_growth_psf_recommended_groups_experiment',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig();
